const SUFFIXES = ['', 'K', 'M', 'B', 'T', 'Qa', 'Qi', 'Sx', 'Sp', 'Oc', 'No', 'Dc'];

export function formatNumber(n: number): string {
  if (!isFinite(n) || n < 0) return '0';
  if (n < 1000) return Math.floor(n).toString();
  const tier = Math.min(SUFFIXES.length - 1, Math.floor(Math.log10(n) / 3));
  const scaled = n / Math.pow(10, tier * 3);
  const suffix = SUFFIXES[tier] ?? SUFFIXES[SUFFIXES.length - 1];
  if (tier === 1) return scaled.toFixed(1) + suffix;
  return scaled.toFixed(2) + suffix;
}

export function formatRate(n: number): string {
  if (n === 0) return '0';
  if (n < 0.01) return n.toFixed(3);
  if (n < 1) return n.toFixed(2);
  if (n < 10) return n.toFixed(1);
  return formatNumber(n);
}
